import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PosSpinnerComponent } from './pos-spinner.component';
import { PosSpinnerService } from 'src/app/@core/services/pos-spinner.service';



@NgModule({
  declarations: [
    PosSpinnerComponent
  ],
  imports: [
    CommonModule
  ],
  providers: [PosSpinnerService],
  exports: [PosSpinnerComponent]
})
export class PosSpinnerModule { }
